(() => {
  if (window.theoricKitPreviewReady) return;
  window.theoricKitPreviewReady = true;
  const openers = new WeakMap();
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-tbr-preview-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.tbrPreviewOpen);
      if (!dialog) return;
      event.preventDefault();
      openers.set(dialog, opener);
      dialog.showModal();
      document.documentElement.classList.add('tbr-preview-open');
      return;
    }
    const closer = event.target.closest('[data-tbr-preview-close]');
    if (closer) closer.closest('dialog').close();
    const dialog = event.target;
    if (dialog.matches?.('dialog.tbr-preview')) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  document.addEventListener('close', event => {
    if (!event.target.matches?.('dialog.tbr-preview')) return;
    if (!document.querySelector('dialog.tbr-preview[open]')) document.documentElement.classList.remove('tbr-preview-open');
    openers.get(event.target)?.focus();
  }, true);
})();
